import { NavLink } from "react-router-dom";
import { copy } from "@wheels-crm/shared-types";
import { signOut } from "../../lib/auth";
import { Button } from "../ui/Button";

const NAV_ITEMS: { to: string; label: string }[] = [
  { to: "/", label: copy.nav.dashboard },
  { to: "/orders", label: copy.nav.orders },
  { to: "/reminders", label: copy.nav.reminders },
  { to: "/clients", label: copy.nav.clients },
  { to: "/leads", label: copy.nav.leads },
  { to: "/reports", label: copy.nav.reports },
];

export function TopBar() {
  return (
    <div className="top-bar">
      <nav className="top-bar-nav">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      <Button onClick={() => signOut()}>{copy.logout}</Button>
    </div>
  );
}
